const firebaseConfig = {
  apiKey: "AIzaSyBv3PqL6HUIGhqr_f-irSLHJ1gSDNWlHSM",
  authDomain: "kjv-strongs-reader.firebaseapp.com",
  projectId: "kjv-strongs-reader",
  storageBucket: "kjv-strongs-reader.appspot.com",
  messagingSenderId: "83695266644",
  appId: "1:83695266644:web:083e8ecdaa861da64276c1",
  measurementId: "G-5LYGD9NHV8"
};

export default firebaseConfig